/* unt-init.js
 * Contains code for initializing UNT library template components
 */

import 'FromWWW/assets/omni/scripts/display.alerts.js';
import { OffCanvasSearch } from 'FromWWW/assets/omni/scripts/search.offcanvas.js';
import { DropdownManager } from 'FromWWW/assets/omni/scripts/display.dropdowns.js';
import { LibraryHours } from 'FromWWW/assets/omni/scripts/display.hours.js';
import { AnchorUtility } from 'FromWWW/assets/omni/scripts/display.anchors.js';
import { IdentifierHelper } from 'FromWWW/assets/omni/scripts/search.identifiers.js';
import { ChatManager } from 'FromWWW/assets/omni/scripts/display.chat.js';
import { SearchDropdown } from 'FromWWW/assets/omni/scripts/search-dropdowns.js';
import dropdownsJson from 'FromWWW/assets/omni/data/dropdowns.json';
import utilsYaml from 'FromWWW/_data/utils.yaml';
import YAML from 'yaml';


export function initializeScripts() {
  const utilsData = YAML.parse(utilsYaml);
  window.untLib = {
    respectDnt: ['1', 'yes'].includes(navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack),
    searchDropdowns: utilsData.search_dropdowns
  };
  const offCanvasSearchUtil = new OffCanvasSearch();
  const dropdownManager = new DropdownManager({
    dataSrc: dropdownsJson,
  });
  const libraryHours = new LibraryHours(dropdownManager);
  const anchorUtility = new AnchorUtility();
  const identifierHelper = new IdentifierHelper();
  new SearchDropdown(
    'bento-offcanvas-other-search-options',
    'bento-offcanvas-q',
    window.untLib.searchDropdowns["default_bento"]
  );
  const chatManager = new ChatManager();
}

export { onDomReady, optInTooltips } from 'FromWWW/assets/omni/scripts/utils.js';
